import React from "react"

import {
  SparklesIcon,
  CurrencyDollarIcon,
  ExclamationCircleIcon,
  CheckIcon,
  GiftIcon,
  StarIcon,
} from '@heroicons/react/outline'

import withLocation from "../common/withlocation"
import { GrowthChange, getGrowthChange } from "../common/growthChange"

/** Monthly visitors / pageviews for a topic; entire block only when `?stats=1`. */
const TopicMonthlyStats = ({ topic, communities, queryParams }) => {
  const showStats = queryParams?.stats === '1';
  if (!showStats) {
    return null;
  }

  const statsToShow = [
    {
      name: 'Visitors / mo',
      stat: topic.visitors,
      prev: topic.visitorsPrev,
    },
    {
      name: 'Pageviews / mo',
      stat: topic.views,
      prev: topic.viewsPrev,
    },
  ]

  const topCommunitiestoShow = 25;
  const showWarnings = queryParams.warnings && queryParams.warnings === '1';
  const redirectCounts = communities.slice(0, topCommunitiestoShow).filter(c => c.redirects).map(c => c.redirects);
  const maxRedirects = redirectCounts.length ? Math.max(...redirectCounts) : 1;

  return (
    <section aria-labelledby="topic-stats">
      <div className="rounded-lg bg-white overflow-hidden shadow p-6">
        
        <div className="relative">
          <div className="absolute inset-0 flex items-center" aria-hidden="true">
            <div className="w-full border-t border-gray-200" />
          </div>
          <div className="relative flex items-center">
            <h2 className="pr-3 bg-white text-xl font-medium text-gray-900">
              Monthly Stats
            </h2>
          </div>
        </div>

        <div className={`mt-2`}>
          <dl className="rounded-lg w-full sm:flex">
            {statsToShow.map((item) => {
              const change = getGrowthChange(item.stat, item.prev)
              return (
                <div key={item.name} className="p-0.5 flex-1 text-center flex flex-col items-center">
                  <dd className="text-lg font-semibold text-rose-500">
                    {item.stat}
                  </dd>
                  <dt className="text-sm font-normal text-gray-600">
                    {item.name}
                  </dt>
                  {change ? (
                    <GrowthChange
                      change={change}
                      className="mt-0.5 font-normal"
                    />
                  ) : null}
                </div>
              )
            })}
          </dl>

          <div className="mt-2">
            {communities.filter((c, i) => i < topCommunitiestoShow).map((c, index) => {
              const change = getGrowthChange(c.redirects, c.redirectsPrev)
              return (
              <div key={c.slug} className="flex mt-1 items-center">
                <div className="mr-2 w-6 flex-shrink-0 text-center text-sm font-bold text-gray-300">
                  #{index + 1}
                </div>
                <div className="w-full flex flex-grow-1 relative items-center h-7">
                  <div className="absolute bg-gray-200 rounded-sm p-1 h-full" style={{width: (100 * c.redirects / maxRedirects) + '%'}}></div>
                  <div className="absolute text-gray-600 p-1 px-2 text-white text-xs max-w-full whitespace-nowrap overflow-ellipsis flex-shrink-0 truncate flex items-center">
                    {c.redirects}{" "}
                    <span className="ml-1 opacity-50">clicks/mo</span>
                    {change ? (
                      <GrowthChange change={change} className="ml-1" />
                    ) : null}
                  </div>
                </div>
                <div className="ml-auto flex-shrink-0 pl-2 text-center text-sm font-bold text-gray-300 flex space-x-2">
                  {c.topics.split(',').length > 2 && !c.gold && showWarnings ? (
                    <ExclamationCircleIcon className={`flex-shrink-0 h-5 w-5 ${c.claimed ? 'text-red-500' : 'text-red-200'}`} aria-hidden="true"/>
                  ) : ''}

                  {(c.sponsored || c.promoted) && c.promotedTopics.includes(topic.slug) ? (
                    <CurrencyDollarIcon className="flex-shrink-0 h-5 w-5 text-yellow-400" aria-hidden="true" />
                  ) : c.gold ? (
                    <SparklesIcon className="flex-shrink-0 h-5 w-5 text-yellow-400" aria-hidden="true" />
                  ) : c.affiliate ? (
                    <StarIcon className="flex-shrink-0 h-5 w-5 text-yellow-400" aria-hidden="true" />
                  ) : c.claimed ? (
                    <CheckIcon className="flex-shrink-0 h-5 w-5 text-gray-300" aria-hidden="true"/>
                  ) : (
                    <GiftIcon className="flex-shrink-0 h-5 w-5 text-white" aria-hidden="true"/>
                  )}
                </div>
              </div>
            )})}
          </div>
        </div>
      </div>
    </section>
  )
}

export default withLocation(TopicMonthlyStats);
